export enum ButtonTypeEnum {
  POSTBACK = 'postback',
  QUICK_REPLY = 'quick-reply',
}
